<template lang="pug">
  a.part-footer-email(
    :href="`mailto:${value}`"
    :class="{ inline }"
  ) {{ value }}
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },

    inline: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.part-footer-email {
  color: #6e6bce;
  font-weight: 400;
  font-family: 'Open Sans', sans-serif;
  display: block;

  &:hover {
    color: #51acff;
    text-decoration: none;
  }
}

.inline {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// Email.vue?443df10e